/* eslint import/prefer-default-export: "off" */
import { isEqual as isEqualLodash } from 'lodash'
export function isEqual<T>(
  value: T,
  other: T,
  exclude: Extract<keyof T, string>[] = []
) {
  const a = { ...value }
  const b = { ...other }
  exclude.forEach(key => {
    delete a[key]
    delete b[key]
  })
  return isEqualLodash(a, b)
}
